import { SET_SETTINGS } from "./types";

export const setSettings = (payload) => ({
  type: SET_SETTINGS,
  payload,
});
